<template>
  <v-container class="app-page-container">
        <v-card class="shadow-none app-page-card">
          
<!--           <div>
          <v-navigation-drawer
            v-model="filterBTN"
            class="filter-sidebar"
            absolute
            temporary
            width="none"> -->
            <!-- width="none" = mensi hack proti prideleniu vuetify automatickej sirky pomocou inline CSS -->
           <!--    <div class="navigation-drawer__title-header">Filter: </div>
              <v-container>
                  <v-combobox
                      v-model="selected_areas"
                      :items="areas"
                      label="Select languages"
                      clearable
                      multiple                        
                      small-chips
                      @change="addArea()"
                  ></v-combobox>

                  <v-select
                    :items="courses"
                    filled
                    label="Course"
                  ></v-select>

                  <v-select
                    :items="countries"
                    filled
                    label="Country"
                  ></v-select>

                  <v-select
                    :items="groups"
                    filled
                    label="Group"
                  ></v-select>
              </v-container>
          </v-navigation-drawer>
          </div> -->
          

            <v-card-title>
               <v-flex xs6>
                  Leaderboard
               </v-flex>
               <v-flex xs6>
                    <div class="card-custom-button vertically-horizontally-centered float-right" @click="showFilter = !showFilter"><v-icon>filter_alt</v-icon> Filter</div>
               </v-flex>
            </v-card-title>
            <div class="leaderboard__filter-part" v-if="showFilter">
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-combobox
                            v-model="selected_areas"
                            :items="areas"
                            item-text="name"
                            item-value="id"
                            label="Select languages"
                            clearable
                            multiple                        
                            small-chips
                      ></v-combobox>
                  </v-col>
                  <v-col cols="12"  md="6">
                    <v-combobox
                            v-model="selected_courses"
                            :items="courses"
                            item-text="name"
                            item-value="id"
                            label="Select course"
                            clearable
                            multiple                        
                            small-chips       
                      ></v-combobox>
                  </v-col>
                  <v-col cols="12" md="6">
                      <v-combobox
                            v-model="selected_groups"
                            :items="groups"
                            item-text="name"
                            item-value="id"
                            label="Select group"
                            clearable
                            multiple                        
                            small-chips         
                      ></v-combobox>
                  </v-col>
                  <v-col cols="12" md="6">
                      <v-combobox
                            v-model="selected_countries"
                            :items="countries"
                            item-text="name"
                            item-value="id"
                            label="Select country"
                            clearable
                            multiple                        
                            small-chips       
                      ></v-combobox>
                  </v-col>
                  <v-col cols="12"><small>{{users_count}} users</small><v-btn @click="applyFilter()" class="btn-style btn-primary float-right">Apply</v-btn></v-col>
                </v-row>
              </v-card-text>
            </div>
            
          <v-card-text>
            <v-card class="shadow-none">
            <v-pagination
              @input="showPage()"
              v-model="page"
              class="my-4 leaderboard__pagination"
              :length="pagesCount"
              :total-visible="10"
              circle
            ></v-pagination>
            </v-card> 
          </v-card-text>
          <v-card-text v-if="!visible_leadersboard">
            <v-row class="leaderboard-mobile__item-header" justify="center" no-gutters>
              <small>... reading ...</small>
            </v-row>
          </v-card-text>

          <v-card-text v-if="visible_leadersboard" v-bind:class="[filterBTN ? 'navigation-drawer--opened' : '', 'leaderboard mobile-hidden transform-animation']">
              <v-layout row wrap class="leaderboard__head">
                <v-flex xs1 offset-1> 
                  position
                </v-flex>
                <v-flex xs1> 
                    
                </v-flex>
                <v-flex xs2> 
                  nickname
                </v-flex>
                <v-flex xs1> 
                  xp
                </v-flex>
                <v-flex xs2> 
                  country
                </v-flex>
                <v-flex xs1> 
                  level
                </v-flex>
                <v-flex xs2> 
                  groups
                </v-flex>
              </v-layout>
              <v-layout row wrap v-for="(leader, index) in leaderList" :key="index" @click="prepareUserCourses(index)" class="leaderboard__row"> 
                <v-flex xs1 offset-1> 
                  {{(page-1)*100 + index+1}}.
                </v-flex>
                <v-flex xs1> 
                    <v-avatar
                      :color="getColor(leader.nickname)"
                      class="leaderboard__avatar"
                    >
                      <span style="color:white">{{getAvatar(leader.nickname)}}</span>                      
                    </v-avatar>
                </v-flex>
                <v-flex xs2> 
                  {{leader.nickname}}
                </v-flex>
                <v-flex xs1> 
                  {{leader.xp}}
                </v-flex>
                <v-flex xs2> 
                  {{leader.country}}
                </v-flex>
                <v-flex xs1> 
                  {{Math.round(leader.xp/1000)+1}}
                </v-flex>
                <v-flex xs2> 
                  {{leader.groups}}                  
                </v-flex>
                <v-flex xs2 v-if="index == showIndex">
                </v-flex>
                
                <div v-if="index == showIndex" class="leaderboard__user-details">
                  <v-card class="leaderboard__user-details-card border-style border-radius-md shadow-none">
                      <v-card-text>
                        <h3 class="user-details-card__title">Details of courses:</h3>
                        <ul>
                          <li v-for="(course, index) in courseList" :key="index">
                             <v-row>
                               <v-col cols="3">
                                 {{course.name}} 
                               </v-col>
                               <v-col cols="3">
                                 <v-progress-linear 
                                    height="10"
                                    :value="course.progress">
                                 </v-progress-linear> 
                      
                               </v-col>
                               <v-col cols="2">
                                 <span>{{course.progress}}%</span>
                               </v-col>
                               <v-col cols="4">
                                 {{course.score}} / {{course.max}}
                               </v-col>
                             </v-row>
                          </li>
                        </ul>
                      </v-card-text> 
                  </v-card>
                </div>
              </v-layout>
          </v-card-text>


          <v-card-text class="leaderboard-mobile">
            <v-row>
              <v-col v-for="(leader, index) in leaderList" :key="index" @click="prepareUserCourses(index)" cols="12" class="leaderboard-mobile__item">
                <v-row class="leaderboard-mobile__item-header" justify="center" no-gutters>
                    <v-col cols="8">
                        <span class="leaderboard-mobile__item-rank"><b>{{index+1}}.</b></span>
                        <v-avatar :color="getColor(leader.nickname)" class="leaderboard__avatar">
                              <span style="color:white">{{getAvatar(leader.nickname)}}</span>                      
                        </v-avatar>
                        <span>{{leader.nickname}}</span>
                    </v-col>

                    <v-col cols="2">
                        <span>{{leader.xp}} XP</span>
                    </v-col>

                    <v-col cols="2">
                        <span class="leaderboard-mobile__item-lvl"><b>{{Math.round(leader.xp/1000)+1}}</b></span>
                    </v-col>
                </v-row>

                <div v-if="index == showIndex" class="leaderboard-mobile__user-details">
                 <v-card class="leaderboard__user-details-card border-style background-transparent border-radius-md shadow-none">
                      <v-card-text>
                        <h3 class="user-details-card__title">Details of courses:</h3>
                        <ul>
                          <li v-for="(course, index) in courseList" :key="index">
                             <v-row>
                               <v-col cols="12">
                                 {{course.name}} 
                               </v-col>
                               <v-col cols="4">
                                 <v-progress-linear 
                                    height="10"
                                    :value="course.progress">
                                 </v-progress-linear> 
                      
                               </v-col>
                               <v-col cols="4">
                                 <span>{{course.progress}}%</span>
                               </v-col>
                               <v-col cols="4">
                                 {{course.score}} / {{course.max}}
                               </v-col>
                             </v-row>
                          </li>
                        </ul>
                      </v-card-text> 
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-card class="shadow-none">
            <v-pagination
              @input="showPage()"
              v-model="page"
              class="my-4 leaderboard__pagination"
              :length="pagesCount"
              :total-visible="10"
              circle
            ></v-pagination>
            </v-card> 
          </v-card-text>


        </v-card>
  </v-container>
</template>


<script>
import axios from '../../axios-auth.js'

  export default {
    data() {
      return {
        leaderList: null,
        users_count: 0,
        colors: ["red","orange","green","cyan","blue","purple","pink","grey","brown"],
        showIndex : -1,
        showFilter: false,
        courseList: [],
        competitionList: [],
        areas: [{id: 1, name: 'Java'},{id:2, name: 'Python'}, {id:3, name: 'C/C++'}],
        courses: ['Java fundamentals', 'Python intermediate', 'C advanced'],
        countries: ['SK', 'PL', 'CZ', 'ES'],
        groups: ['UKF', 'ULPGC', 'UP', 'US', 'Mendelu'],
        selected_areas: [],
        selected_courses: [],
        selected_countries: [],
        selected_groups: [],
        filterBTN: false,
        search1 :null,
        filter_data: { areas:'', courses:'', countries: '', groups: '', start : 0, end : 100}, // settings for filter
        page: 1,
        pagesCount: 1,
        visible_leadersboard: false
      }
    },
    mounted () {
      this.initData()
   },
   methods: {
    initData() { 
      this.$store.commit('setBreadCrumbs',[{text: 'Leaderboard', href: '/leaderboard'}])//#
      this.getLeadersFilterData()
      this.getMyLeaders(0,100)
    },
    getLeadersFilterData() {
      axios.get('/get-leaders-filter-data', this.$store.getters.getAxiosConfig)
        .then(res => {
            this.areas = res.data.areas
            this.courses = res.data.courses
            this.countries = res.data.countries
            this.groups = res.data.groups
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })

    },
    getMyLeaders(start,end) {
      this.filter_data.start = start
      this.filter_data.end = end
      this.visible_leadersboard = false
      axios.post('/get-leaders2', this.filter_data, this.$store.getters.getAxiosConfig)
        .then(res => {
            // set data to store
            this.showIndex = -1
            this.users_count = res.data.count
            this.visible_leadersboard = true
            if (res.data.list == 'empty') {
              this.leaderList = null 
              this.pagesCount = 1  
            } else {
              this.leaderList = res.data.list
              this.pagesCount = Math.trunc(res.data.count / 100)
              if (Math.trunc(res.data.count % 100 > 1)) this.pagesCount++
            }
            /* eslint-disable no-console */
            // console.log(res.data)  
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    getAvatar(txt) {
      if (txt.length == 0) return "XY"
      if (txt.length < 3) return txt
      txt = txt.trim()
      var av = txt.substring(0,1).toUpperCase()
      var index = txt.indexOf(" ")
      if (index == -1) index = txt.indexOf("_")
      if (index == -1) index = txt.indexOf(".")
      if (index > 0) av = av + txt.substring(index+1,index+2).toUpperCase()
      return av
    },
    getColor(txt) {
      let av = this.getAvatar(txt)
      var n = av.charCodeAt(0)
      if (av.length > 1) n = n + av.charCodeAt(0)
      n = n % 9
      if (n < 0) n = 0
      if (n > this.colors.length-1) n = this.colors.length-1
      return this.colors[n]
    },
    prepareUserCourses(index) {
      this.showIndex = index
      axios.get('/get-leader-course/' + this.leaderList[index].id, this.$store.getters.getAxiosConfig)
        .then(res => {
            // set data to store            
            this.courseList = res.data.list
            /* eslint-disable no-console */
            //console.log(res.data)         
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    applyFilter() {
      // this.areas.push(this.selected_area)
      this.filter_data = {
        areas: this.getSelectedList(this.selected_areas),
        courses: this.getSelectedList(this.selected_courses),
        countries: this.getSelectedList(this.selected_countries),
        groups: this.getSelectedList(this.selected_groups),
        start: 0,
        end: 100
      }
      this.page = 1
      this.getMyLeaders(0,100)
    },
    getSelectedList(mylist) {
      var res = ''
      for(let i=0; i<mylist.length; i++) {
        if (mylist[i].id != null) {
          if (res.length>0) res += "," + mylist[i].id 
          else res = "" + mylist[i].id
        }
      }
      return res
    },
    prepareFilter() {
        this.filterBTN = !this.filterBTN
    },
    showPage() {
      //console.log(this.page)
      this.getMyLeaders((this.page-1)*100,this.page*100)
    }
   }
  }
</script>

<style>

</style>